import React from "react";
import { Timer, AlertTriangle } from "lucide-react";

const URGENCY = {
  overdue:  { bg: "bg-rose-500",    text: "text-rose-500",    label: "Scaduta" },
  critical: { bg: "bg-rose-500",    text: "text-rose-400",    label: "≤ 7 giorni" },
  warning:  { bg: "bg-amber-500",   text: "text-amber-400",   label: "≤ 3 settimane" },
  ok:       { bg: "bg-emerald-500", text: "text-emerald-400", label: "In tempo" },
  unknown:  { bg: "bg-slate-500",   text: "text-slate-400",   label: "—" },
};

export default function Countdown({ countdown, dark = false, compact = false }) {
  if (!countdown || countdown.days_remaining == null) return null;
  const u = URGENCY[countdown.urgency] || URGENCY.unknown;
  const dr = countdown.days_remaining;
  const isOver = dr < 0;
  const displayDays = Math.abs(dr);
  const subLabel = isOver ? `Scaduta da ${displayDays} giorni` : `${displayDays} giorni residui`;

  if (compact) {
    return (
      <div className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs ${dark ? "bg-white/5" : "bg-muted"}`} data-testid="countdown-compact">
        <Timer className={`w-3.5 h-3.5 ${u.text}`} />
        <span className={dark ? "text-slate-400" : "text-muted-foreground"}>Chiusura</span>
        <span className={`font-heading font-semibold tabular-nums ${u.text}`}>{isOver ? "-" : ""}{displayDays}g</span>
      </div>
    );
  }

  return (
    <div className={`rounded-xl border ${dark ? "border-white/10 bg-white/5" : "border-border/60 bg-muted/30"} p-4`} data-testid="countdown-card">
      <div className={`flex items-center gap-1.5 text-xs uppercase tracking-wider mb-2 ${dark ? "text-slate-400" : "text-muted-foreground"}`}>
        {isOver ? <AlertTriangle className="w-3.5 h-3.5" /> : <Timer className="w-3.5 h-3.5" />}
        Conto alla rovescia
      </div>
      <div className="flex items-baseline gap-2">
        <span className={`font-heading text-4xl font-bold tabular-nums leading-none ${u.text}`} data-testid="countdown-days">{isOver ? "-" : ""}{displayDays}</span>
        <span className={`text-sm ${dark ? "text-slate-400" : "text-muted-foreground"}`}>giorni</span>
        <span className={`ml-auto text-[10px] font-semibold px-2 py-0.5 rounded-full ${u.bg} text-white`} data-testid="countdown-urgency">{u.label}</span>
      </div>
      <p className={`text-xs mt-1 ${dark ? "text-slate-400" : "text-muted-foreground"}`}>{subLabel}</p>
      {countdown.total_days && (
        <div className="mt-3">
          <div className={`h-1.5 rounded-full overflow-hidden ${dark ? "bg-white/10" : "bg-muted"}`}>
            <div className={`h-full ${u.bg} transition-all`} style={{ width: `${Math.min(100, countdown.progress_pct || 0)}%` }} />
          </div>
          <div className={`mt-1.5 flex justify-between text-[10px] tabular-nums ${dark ? "text-slate-400" : "text-muted-foreground"}`}>
            <span>Giorno {countdown.elapsed_days || 0}</span>
            <span>di {countdown.total_days}</span>
          </div>
        </div>
      )}
      {countdown.deadline && (
        <div className={`text-[10px] mt-2 tabular-nums ${dark ? "text-slate-500" : "text-muted-foreground"}`}>
          Deadline: {new Date(countdown.deadline).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" })}
        </div>
      )}
    </div>
  );
}
